
















import { Component, Vue } from "vue-property-decorator";
import IconCustom from "@/components/lib/IconCustom.vue";
import { Theme } from "@/store";

@Component({
  components: {
    IconCustom,
  },
})
export default class ThemeSwitcher extends Vue {
  get theme(): Theme {
    return this.$store.state.theme;
  }

  get toggled(): boolean {
    return this.theme === "dark";
  }

  private switchTheme() {
    let theme: Theme = this.theme === "dark" ? "light" : "dark";
    this.$store.dispatch("setCheckboxLabelColor", this.theme === "light");
    this.$storage.actions.setTheme(theme);
  }
}
